'use strict';
import {gsap} from "gsap/all";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { CustomEase } from "gsap/CustomEase";
import { SplitText } from "gsap/SplitText";
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(CustomEase);
gsap.registerPlugin(SplitText);

var displayMarkers = false;
let pinSpacing = window.innerWidth <= 1024;

function updatePinSpacing() {
    pinSpacing = window.innerWidth <= 1024;
}

window.addEventListener('resize', () => {
    updatePinSpacing();
});

updatePinSpacing();

(function ($) {
    $(window).on('load statechangecomplete', function () {

        if ($('.splittext').length) {
            gsap.utils.toArray(".splittext").forEach(function (elem) {
                const splitTimeline = gsap.timeline({scrollTrigger: {
                        trigger: elem,
                        start: "top bottom",
                        end: "top top",
                        onEnter: self => gsap.to(elem, {opacity: self.isActive ? 1 : 0}),
                        markers: displayMarkers
                    }
                });

                const splitTitle = new SplitText(elem, {type: 'words, chars', linesClass: 'split--line', wordsClass: 'split--word', charsClass: 'split--char'});
                var splitTitleStagger = 0.06;
                if ($(elem).data('stagger')) {
                    splitTitleStagger = $(elem).data('stagger');
                }
                splitTimeline.from(splitTitle.words, {opacity: 0, yPercent: 100, delay: 0.6, stagger: splitTitleStagger, ease: "back.out(1)", overwrite: "auto"});
            });
        }

        const cards = gsap.utils.toArray(".stacking-testimonials-slider .panel");
        if (cards.length > 0) {
            const spacer = 10;
            const minScale = 0.8;
            const distributor = gsap.utils.distribute({ base: minScale, amount: 0.2 });

            cards.forEach((card, index) => {
                const scaleVal = distributor(index, cards[index], cards);
                //const contentBlocks = card.querySelector(".card-content");

                gsap.timeline({
                    scrollTrigger: {
                        trigger: card,
                        scrub: true,
                        markers: false,
                        start: `top+=${index * spacer} 20px`,
                        endTrigger: ".stacking-testimonials-slider",
                        end: `bottom top+=${200 + cards.length * spacer}`,
                        pin: true,
                        pinSpacing: pinSpacing,
                        id: "pin",
                        invalidateOnRefresh: true
                    },
                })

                    .to(card, {
                        ease: "none",
                        scale: scaleVal,
                        duration: .2
                    });
            });
        }


        if($('.to-small').length) {
            $('.to-small').each(function () {
                let image = $(this);
                gsap.fromTo(
                    image,
                    { scale: 1.2 },
                    {
                        scale: 1,
                        ease: "none",
                        force3D: true,
                        scrollTrigger: {
                            pin: image,
                            trigger: image,
                            start: "top top",
                            end: "bottom top",
                            scrub: 0.5,
                        },
                    }
                );
            })
        }

        if($('.to-small-right').length) {
            $('.to-small-right').each(function () {
                let image = $(this);
                gsap.fromTo(
                    image,
                    { scale: 1.5, transformOrigin: "right top" },
                    {
                        scale: 1,
                        ease: "none",
                        scrollTrigger: {
                            trigger: image,
                            start: "top bottom",
                            end: "bottom bottom",
                            scrub: 1,
                        },
                    }
                );
            })
        }

        if ($('[data-batch="from-bottom"]').length) {
            gsap.set('[data-batch="from-bottom"]', {opacity: 0, y: 100});
            ScrollTrigger.batch('[data-batch="from-bottom"]', {
                interval: 0.1, // time window (in seconds) for batching to occur. 
                batchMax: 3, // maximum batch size (targets). Can be function-based for dynamic values
                onEnter: batch => gsap.to(batch, {opacity: 1, y: 0, stagger: 0.15}),
                // you can also define most normal ScrollTrigger values like start, end, etc.
                markers: displayMarkers,
                start: "20px bottom",
                end: "top top"
            });
        }

        if ($('[data-animate="horizontal-slices"]').length) {
            $('[data-animate="horizontal-slices"]').each((_, sectionHtml) => {
                var delay = 0.6;
                if ($(sectionHtml).data('delay')) {
                    delay = $(sectionHtml).data('delay');
                }
                gsap
                        .timeline(
                                {
                                    defaults: {
                                        ease: CustomEase.create("custom", "M0,0 C0.083,0.294 0.006,0.698 0.272,0.888 0.403,0.981 0.752,1 1,1 "),
                                        duration: 1,
                                        delay: delay,
                                    },
                                    scrollTrigger: {
                                        markers: displayMarkers,
                                        trigger: $(sectionHtml),
                                        start: 'top bottom',
                                        end: 'top top',
                                    },
                                })
                        .fromTo($(sectionHtml),
                                {clipPath: "polygon(100% 50%, 0% 50%, 0% 0%, 0% 0%, 0% 50%, 100% 50%, 100% 100%, 100% 100%)"},
                                {clipPath: "polygon(100% 50%, 100% 50%, 100% 0%, 0% 0%, 0% 50%, 0% 50%, 0% 100%, 100% 100%)"}
                        );
            });
        }

        if ($('[data-animate="bottom-to-top"]').length) {
            $('[data-animate="bottom-to-top"]').each((_, sectionHtml) => {
                var delay = 0.6;
                if ($(sectionHtml).data('delay')) {
                    delay = $(sectionHtml).data('delay');
                }
                var image = $(sectionHtml).find('img').eq(0);
                gsap.set($(sectionHtml), {clipPath: "polygon(0 100%, 100% 100%, 100% 100%, 0 100%)"})
                gsap.set(image, {scale: 1.2});
                gsap.timeline(
                        {
                            defaults: {
                                delay: delay,
                            },
                            scrollTrigger: {
                                markers: displayMarkers,
                                trigger: $(sectionHtml),
                                start: 'top bottom',
                                end: 'top top',
                            },
                        })
                        .fromTo($(sectionHtml),
                                {clipPath: "polygon(0 100%, 100% 100%, 100% 100%, 0 100%)"
                                },
                                {
                                    clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)"
                                }
                        )
                        .fromTo($(image),
                                {
                                    scale: 1.2
                                },
                                {
                                    scale: 1
                                }
                        , "<");

            });
        }

        if ($('[data-animate="top-to-bottom"]').length) {
            $('[data-animate="top-to-bottom"]').each((_, sectionHtml) => {
                var delay = 0.2;
                if ($(sectionHtml).data('delay')) {
                    delay = $(sectionHtml).data('delay');
                }
                var image = $(sectionHtml).find('img').eq(0);
                gsap.set($(sectionHtml), {clipPath: "polygon(0 100%, 100% 100%, 100% 100%, 0 100%)"})
                gsap.set(image, {scale: 1.2});
                gsap.timeline(
                        {
                            defaults: {
                                delay: delay,
                            },
                            scrollTrigger: {
                                markers: displayMarkers,
                                trigger: $(sectionHtml),
                                delay: 0.6,
                                start: 'top bottom',
                                end: 'top top',
                            },
                        })
                        .fromTo($(sectionHtml),
                                {clipPath: "polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)"
                                },
                                {
                                    clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)"
                                }
                        )
                        .fromTo($(image),
                                {
                                    scale: 1.2
                                },
                                {
                                    scale: 1
                                }
                        , "<");

            });
        }

        if ($('[data-animate="scale-on-scroll"]').length) {
            $('[data-animate="scale-on-scroll"]').each((_, sectionHtml) => {
                gsap.set($(sectionHtml), {scale: 0.8});
                gsap.timeline({
                    scrollTrigger: {
                        markers: displayMarkers,
                        trigger: $(sectionHtml),
                        delay: 0.6,
                        start: 'top bottom',
                        end: 'top top',
                    },
                })
                        .fromTo($(sectionHtml),
                                {
                                    opacity: 0,
                                    scale: 0.8
                                },
                                {
                                    opacity: 1,
                                    scale: 1
                                }
                        , "<");
            });
        }

        if ($('[data-animate="anim-image"]').length) {
            gsap.set($('[data-animate="anim-image"]'), {opacity: 0, y: 10, overwrite: true});
            ScrollTrigger.batch($('[data-animate="anim-image"]'), {
                interval: 0.1,
                batchMax: 3,
                markers: displayMarkers,
                onEnter: batch => gsap.to(batch, {opacity: 1, y: 0, stagger: {each: 0.3},duration: 1.5, overwrite: true}),
                start: "20px bottom",
                end: "top top",
            });
        }

        if ($('[data-animate="from-top"]').length) {
            gsap.set($('[data-animate="from-top"]'), {opacity: 0, y: -100, overwrite: true});
            ScrollTrigger.batch($('[data-animate="from-top"]'), {
                interval: 0.1,
                batchMax: 3,
                markers: displayMarkers,
                onEnter: batch => gsap.to(batch, {opacity: 1, y: 0, stagger: {each: 0.15}, overwrite: true}),
                start: "top bottom",
                end: "top top",
            });
        }
        if ($('[data-animate="from-bottom"]').length) {
            gsap.set($('[data-animate="from-bottom"]'), {opacity: 0, y: 100, overwrite: true});
            ScrollTrigger.batch($('[data-animate="from-bottom"]'), {
                interval: 0.1,
                batchMax: 3,
                markers: displayMarkers,
                onEnter: batch => gsap.to(batch, {opacity: 1, y: 0, stagger: {each: 0.15}, overwrite: true}),
                start: "20px bottom",
                end: "top top",
            });
        }
        if ($('[data-animate="from-left"]').length) {
            gsap.set($('[data-animate="from-left"]'), {opacity: 0, x: -100, overwrite: true});
            ScrollTrigger.batch($('[data-animate="from-left"]'), {
                interval: 0.1, // time window (in seconds) for batching to occur. 
                batchMax: 3, // maximum batch size (targets). Can be function-based for dynamic values
                markers: displayMarkers,
                onEnter: batch => gsap.to(batch, {opacity: 1, x: 0, stagger: {each: 0.15}, overwrite: true}),
                start: "20px bottom",
                end: "top top",
            });
        }
        if ($('[data-animate="from-right"]').length) {
            gsap.set($('[data-animate="from-right"]'), {opacity: 0, x: 100, overwrite: true});
            ScrollTrigger.batch($('[data-animate="from-right"]'), {
                interval: 0.1, // time window (in seconds) for batching to occur. 
                batchMax: 3, // maximum batch size (targets). Can be function-based for dynamic values
                markers: displayMarkers,
                onEnter: batch => gsap.to(batch, {opacity: 1, x: 0, stagger: {each: 0.15}, overwrite: true}),
                start: "20px bottom",
                end: "top top",
            });
        }
    });

})(jQuery);


// WEBPACK FOOTER //
// ./scripts/animations.js